import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const ErrorMessage = styled.div`
  text-align: center;
  color: #f00;
  margin-bottom: 20px;
`;

export const QuestionTitle = styled.div`
  text-align: center;
  font-size: 16px;
  margin-top: 60px;
  margin-bottom: 20px;
  color: #000;

  ${media.tabletP`
    font-size: 22px;
    margin-top: 70px;
    margin-bottom: 30px;
  `};
`;

export const QuestionSubTitle = styled.div`
  text-align: left;
  font-size: 14px;
  margin-top: 30px;
  margin-bottom: 20px;
  color: #000;

  ${media.tabletP`
    font-size: 18px;
    margin-top: 70px;
  `};
`;

export const CtaButton = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 20px;
  margin-left: 0;

  ${media.tabletP`
    width: 300px;
    margin-left: calc(50% - 150px);
  `};

  button {
    border: none;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/UserSurveyPage/UserSurveyPage.style.js